import { Automations } from '~/pages/homepage/pages/features/automations'

export default Automations
